import { useEffect, useRef, useState } from "react";

import DataTable from "components/table/DataTable";

import Select from "react-select";

import * as XLSX from "xlsx";

import { showSuccess, showError } from "utils/toast";

// ============================================================
// DEFAULT PAGINATION
// ============================================================
const DEFAULT_PAGINATION = {
  total: 0,
  page: 1,
  limit: 10,
  totalPages: 1,
};

// ============================================================
// PAGINATION PAGE NUMBERS
// ============================================================

const getPaginationPages = (currentPage, totalPages) => {
  const pages = [];
  if (!totalPages || totalPages <= 1) {
    return [1];
  }

  // Small number of pages

  if (totalPages <= 7) {

    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }

    return pages;
  }

  // Beginning

  if (currentPage <= 4) {

    return [1, 2, 3, 4, 5, "...", totalPages];

  }

  // End



  if (currentPage >= totalPages - 3) {



    return [



      1,



      "...",



      totalPages - 4,



      totalPages - 3,



      totalPages - 2,



      totalPages - 1,



      totalPages,



    ];



  }







  // Middle



  return [



    1,



    "...",



    currentPage - 1,



    currentPage,



    currentPage + 1,



    "...",



    totalPages,



  ];



};











// ============================================================



// INITIAL FILTER VALUES



// ============================================================







const getInitialFilterValues = (



  filters = []



) => {







  return filters.reduce(



    (



      acc,



      filter



    ) => {







      acc[



        filter.key



      ] =



        filter.defaultValue ??



        "";







      return acc;







    },



    {}



  );







};











// ============================================================



// CSV ESCAPE



// ============================================================







const escapeCsvValue = (



  value



) => {







  if (



    value === null ||



    value === undefined



  ) {







    return "";







  }











  let stringValue =



    String(value);











  // Remove HTML



  stringValue =



    stringValue.replace(



      /<[^>]*>/g,



      ""



    );











  // Escape quotes



  stringValue =



    stringValue.replace(



      /"/g,



      '""'



    );











  return `"${stringValue}"`;







};











// ============================================================



// NESTED VALUE



// ============================================================







const getNestedValue = (



  object,



  path



) => {







  if (!path) {



    return "";



  }











  return path



    .split(".")



    .reduce(



      (



        value,



        key



      ) =>



        value?.[key],



      object



    );







};











// ============================================================



// COMPONENT



// ============================================================







export default function CrudListing({







  title,







  columns,







  fetchData,







  deleteData,







  Modal,







  modalProps = {},







  responseDataKey =



  "records",







  addButtonText =



  "Add",







  limit = 10,







  localSearch =



  false,







  // SEARCH



  showSearch =



  false,







  // FILTERS



  filters =



  [],







  // IMPORT



  importData =



  null,







  importAccept =



  ".csv,.xlsx,.xls",







}) {

  // Show Import/Export controls only to administrators.
  const loggedInUser = (() => {
    try {
      const rawUser = localStorage.getItem("user");
      if (!rawUser) return {};
      const parsedUser = JSON.parse(rawUser);
      return parsedUser?.user ?? parsedUser?.data?.user ?? parsedUser ?? {};
    } catch {
      return {};
    }
  })();

  const normalizeRole = (value) => {
    if (typeof value === "string") return value;
    if (value && typeof value === "object") {
      return value.name ?? value.designation ?? value.slug ?? value.key ?? value.roleName ?? "";
    }
    return "";
  };

  // The current app stores the logged-in user in localStorage under "user".
  // The supplied user object has name: "Super Admin" and
  // employee.designation: "Super Admin".
  const roleValues = [
    ...(Array.isArray(loggedInUser?.roles) ? loggedInUser.roles : []),
    loggedInUser?.role,
    loggedInUser?.roleName,
    loggedInUser?.role_name,
    loggedInUser?.name,
    loggedInUser?.employee?.designation,
    loggedInUser?.user?.role,
    loggedInUser?.data?.role,
  ]
    .map(normalizeRole)
    .map((role) => String(role).trim().toLowerCase().replace(/[\s-]+/g, "_"));

  const isAdmin = roleValues.some((role) =>
    ["admin", "super_admin", "superadmin"].includes(role)
  );










  // ==========================================================



  // DATA STATES



  // ==========================================================







  const [



    rows,



    setRows,



  ] = useState([]);











  const [



    filteredRows,



    setFilteredRows,



  ] = useState([]);











  const [



    loading,



    setLoading,



  ] = useState(false);











  const [



    page,



    setPage,



  ] = useState(1);











  const [



    search,



    setSearch,



  ] = useState("");











  // ==========================================================



  // FILTER STATES



  // ==========================================================







  const [



    filterValues,



    setFilterValues,



  ] = useState(



    () =>



      getInitialFilterValues(



        filters



      )



  );











  // ==========================================================



  // PAGINATION



  // ==========================================================







  const [



    pagination,



    setPagination,



  ] = useState(



    DEFAULT_PAGINATION



  );











  // ==========================================================



  // MODAL



  // ==========================================================







  const [



    openModal,



    setOpenModal,



  ] = useState(false);











  const [



    selectedItem,



    setSelectedItem,



  ] = useState(null);











  // ==========================================================



  // IMPORT



  // ==========================================================







  const [



    importing,



    setImporting,



  ] = useState(false);











  const importInputRef =



    useRef(null);











  // ==========================================================



  // LOAD DATA



  // ==========================================================







  const loadData =



    async () => {







      try {







        setLoading(



          true



        );











        const response =



          await fetchData(







            page,







            limit,







            localSearch ||



              !showSearch



              ? ""



              : search,







            filterValues







          );











        const data =



          response



            ?.data



            ?.data ||



          {};











        const records =



          data?.[



          responseDataKey



          ] ||



          [];











        setRows(



          Array.isArray(



            records



          )



            ? records



            : []



        );











        setPagination(



          data?.pagination ||



          DEFAULT_PAGINATION



        );











      } catch (error) {







        console.error(



          "CrudListing load error:",



          error



        );











        setRows([]);











        showError(



          error



            ?.response



            ?.data



            ?.message ||



          "Unable to load data."



        );











      } finally {







        setLoading(



          false



        );







      }







    };











  // ==========================================================



  // LOAD WHEN QUERY CHANGES



  // ==========================================================







  useEffect(() => {







    loadData();







  }, [







    page,







    search,







    filterValues,







    localSearch,







    showSearch,







  ]);











  // ==========================================================



  // LOCAL SEARCH



  // ==========================================================







  useEffect(() => {







    if (!localSearch) {







      setFilteredRows(



        rows



      );







      return;







    }











    const keyword =



      search



        .trim()



        .toLowerCase();











    if (!keyword) {







      setFilteredRows(



        rows



      );







      return;







    }











    setFilteredRows(







      rows.filter(



        (item) =>







          JSON.stringify(



            item



          )



            .toLowerCase()



            .includes(



              keyword



            )



      )







    );







  }, [







    rows,







    search,







    localSearch,







  ]);











  // ==========================================================



  // ADD



  // ==========================================================







  const handleAdd =



    () => {







      setSelectedItem(



        null



      );











      setOpenModal(



        true



      );







    };











  // ==========================================================



  // EDIT



  // ==========================================================







  const handleEdit =



    (item) => {







      setSelectedItem(



        item



      );











      setOpenModal(



        true



      );







    };











  // ==========================================================



  // DELETE



  // ==========================================================







  const handleDelete =



    async (id) => {







      if (



        !window.confirm(



          "Delete record?"



        )



      ) {







        return;







      }











      try {







        await deleteData(



          id



        );











        showSuccess(



          "Deleted successfully."



        );











        await loadData();











      } catch (error) {







        console.error(



          "Delete error:",



          error



        );











        showError(







          error



            ?.response



            ?.data



            ?.message ||



          "Unable to delete."







        );







      }







    };











  // ==========================================================



  // FILTER CHANGE



  // ==========================================================


  const handleFilterChange = (key, value) => {
    const changedFilter = filters.find(
      (filter) => filter.key === key
    );

    setFilterValues((previous) => {
      const next = {
        ...previous,
        [key]: value,
      };

      // Clear dependent selections when a parent changes.
      (changedFilter?.clearKeys || []).forEach((childKey) => {
        next[childKey] = "";
      });

      return next;
    });

    setPage(1);

    // Optional callback for loading dependent options.
    changedFilter?.onChange?.(value);
  };











  // ==========================================================



  // CLEAR FILTERS



  // ==========================================================







  const handleClearFilters =



    () => {







      setFilterValues(



        getInitialFilterValues(



          filters



        )



      );











      setPage(



        1



      );







    };











  // ==========================================================



  // ACTIVE FILTER CHECK



  // ==========================================================







  const hasActiveFilters =



    Object.values(



      filterValues



    ).some(



      (value) =>







        value !== "" &&







        value !== null &&







        value !== undefined







    );











  // ==========================================================



  // RENDER FILTER



  // ==========================================================







  const renderFilter =



    (filter) => {







      const value =



        filterValues[



        filter.key



        ] ?? "";











      // ======================================================



      // SELECT



      // ======================================================







      const isSelectFilter =
        filter.type === "select" ||
        filter.type === "searchable-select" ||
        filter.searchable === true;

      if (isSelectFilter) {
        const options = (filter.options || []).map((option) => ({
          value: option.value,
          label: option.label,
        }));

        const useSearchableSelect =
          filter.type === "searchable-select" ||
          filter.searchable === true;

        return (
          <div
            key={filter.key}
            className="min-w-[220px] flex-1"
          >
            <label className="mb-2 block text-sm font-semibold text-gray-700">
              {filter.label}
            </label>

            {useSearchableSelect ? (
              <Select
                inputId={`filter-${filter.key}`}
                options={options}
                value={
                  options.find(
                    (option) =>
                      String(option.value ?? "") === String(value ?? "")
                  ) || null
                }
                onChange={(selectedOption) =>
                  handleFilterChange(
                    filter.key,
                    selectedOption?.value ?? ""
                  )
                }
                isSearchable
                isClearable={filter.isClearable ?? true}
                placeholder={filter.placeholder || `All ${filter.label}`}
                noOptionsMessage={() => filter.noOptionsMessage || "No results found"}
                menuPortalTarget={
                  typeof document !== "undefined" ? document.body : undefined
                }
                styles={{
                  control: (base, state) => ({
                    ...base,
                    minHeight: 51,
                    borderRadius: 10,
                    borderColor: state.isFocused ? "#4935ff" : "#cbd5e1",
                    boxShadow: state.isFocused ? "0 0 0 1px #4935ff" : "none",
                    "&:hover": {
                      borderColor: state.isFocused ? "#4935ff" : "#94a3b8",
                    },
                    fontSize: 14,
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    padding: "2px 12px",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: 14,
                    backgroundColor: state.isSelected
                      ? "#4935ff"
                      : state.isFocused
                      ? "#eef2ff"
                      : "#ffffff",
                    color: state.isSelected ? "#ffffff" : "#111827",
                    cursor: "pointer",
                  }),
                }}
              />
            ) : (
              <select
                value={value}
                onChange={(event) =>
                  handleFilterChange(filter.key, event.target.value)
                }
                className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-sm outline-none focus:border-brand-500"
              >
                <option value="">
                  {filter.placeholder || `All ${filter.label}`}
                </option>

                {options.map((option) => (
                  <option
                    key={String(option.value)}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
            )}
          </div>
        );
      }

      // ======================================================







      if (



        filter.type ===



        "date"



      ) {







        return (







          <div



            key={



              filter.key



            }



            className="



              min-w-[220px]



              flex-1



            "



          >







            <label



              className="



                mb-2



                block



                text-sm



                font-semibold



                text-gray-700



              "



            >







              {



                filter.label



              }







            </label>











            <input







              type="date"







              value={



                value



              }







              onChange={



                (event) =>



                  handleFilterChange(



                    filter.key,



                    event.target.value



                  )



              }







              className="



                w-full



                rounded-lg



                border



                border-gray-300



                bg-white



                px-3



                py-2.5



                text-sm



                outline-none



                focus:border-brand-500



              "







            />







          </div>







        );







      }











      return null;







    };











  // ==========================================================



  // IMPORT CLICK



  // ==========================================================







  const handleImportClick =



    () => {







      if (!importData) {







        showError(



          "Import functionality is not configured."



        );







        return;







      }











      importInputRef



        .current



        ?.click();







    };











  // ==========================================================



  // IMPORT FILE



  // ==========================================================







  const handleImportFile =



    async (



      event



    ) => {







      const file =



        event



          .target



          .files?.[0];











      // Allow selecting same file again



      event.target.value =



        "";











      if (!file) {



        return;



      }











      // ======================================================



      // VALIDATE EXTENSION



      // ======================================================







      const allowedExtensions =



        [



          ".csv",



          ".xlsx",



          ".xls",



        ];











      const fileName =



        file.name



          .toLowerCase();











      const validExtension =



        allowedExtensions.some(



          (



            extension



          ) =>



            fileName.endsWith(



              extension



            )



        );











      if (!validExtension) {







        showError(



          "Please select a CSV or Excel file."



        );







        return;







      }











      // ======================================================



      // VALIDATE SIZE



      // ======================================================







      const maxSize =



        10 *



        1024 *



        1024;











      if (



        file.size >



        maxSize



      ) {







        showError(



          "File size must be less than 10 MB."



        );







        return;







      }











      // ======================================================



      // UPLOAD



      // ======================================================







      try {







        setImporting(



          true



        );











        await importData(



          file



        );











        showSuccess(



          "Schools imported successfully."



        );











        // ====================================================



        // Reload first page



        // ====================================================







        setPage(



          1



        );











        await loadData();











      } catch (error) {







        console.error(



          "Import error:",



          error



        );











        showError(







          error



            ?.response



            ?.data



            ?.message ||







          "Unable to import schools."







        );







      } finally {







        setImporting(



          false



        );







      }







    };











  // ==========================================================



  // ==========================================================

  // EXPORT CSV - EXPORT ALL PAGES

  // ==========================================================





  const handleExport = async () => {

    try {

      const exportColumns = (

        Array.isArray(tableColumns) ? tableColumns : []

      ).filter((column) => {

        const key = column?.accessorKey || column?.id;



        return (

          key &&

          !["actions", "action", "select"].includes(key)

        );

      });



      if (!exportColumns.length) {

        showError("No exportable columns found.");

        return;

      }



      // Fetch all pages without changing the visible listing.

      let allRows = [];

      let currentPage = 1;

      let totalPages = Math.max(

        1,

        Number(pagination?.totalPages) || 1

      );



      const exportLimit = Math.max(1, Number(limit) || 10);

      const exportSearch =

        localSearch || !showSearch ? "" : search;



      do {

        const response = await fetchData(

          currentPage,

          exportLimit,

          exportSearch,

          filterValues

        );



        const data = response?.data?.data || {};

        const pageRows = data?.[responseDataKey];



        if (!Array.isArray(pageRows)) {

          throw new Error("Export records were not found in the API response.");

        }



        allRows.push(...pageRows);



        const apiTotalPages = Number(data?.pagination?.totalPages);



        if (Number.isFinite(apiTotalPages) && apiTotalPages > 0) {

          totalPages = apiTotalPages;

        } else if (pageRows.length < exportLimit) {

          totalPages = currentPage;

        }



        currentPage += 1;

      } while (currentPage <= totalPages);



      if (!allRows.length) {

        showError("No records available to export.");

        return;

      }



      const formatValue = (value) => {

        if (value == null) return "";



        if (value instanceof Date) {

          return value.toLocaleString();

        }



        if (Array.isArray(value)) {

          return value.map((item, index) => {

            if (!item || typeof item !== "object") {

              return `${index + 1}. ${String(item ?? "")}`;

            }



            const school =

              item.school?.name ||

              item.school?.schoolName ||

              item.school?.schoolCode ||

              "";



            const party =

              item.party?.name ||

              item.party?.partyName ||

              "";



            const lines = [

              `Visit ${index + 1}`,

              item.itemType ? `Type: ${item.itemType}` : "",

              school ? `School: ${school}` : "",

              party ? `Party: ${party}` : "",

              item.plannedTime ? `Time: ${item.plannedTime}` : "",

              item.purpose ? `Purpose: ${item.purpose}` : "",

              item.priority ? `Priority: ${item.priority}` : "",

              item.claimAmount != null

                ? `Claim Amount: ${item.claimAmount}`

                : "",

              item.status ? `Status: ${item.status}` : "",

              item.remarks ? `Remarks: ${item.remarks}` : "",

            ].filter(Boolean);



            return lines.join(" | ");

          }).join("\n\n");

        }



        if (typeof value === "object") {

          return (

            value.name ??

            value.employeeCode ??

            value.title ??

            JSON.stringify(value)

          );

        }



        return value;

      };



      const headers = exportColumns.map((column) =>

        typeof column.header === "string"

          ? column.header

          : String(column.accessorKey || column.id || "Column")

      );



      const excelRows = allRows.map((row) =>

        exportColumns.map((column) => {

          let value;



          if (typeof column.accessorFn === "function") {

            value = column.accessorFn(row);

          } else {

            value = getNestedValue(

              row,

              column.accessorKey || column.id

            );

          }



          return formatValue(value);

        })

      );



      // Create a real Excel workbook, not a CSV file.

      const worksheet = XLSX.utils.aoa_to_sheet([

        headers,

        ...excelRows,

      ]);



      // Make headers bold and improve column widths.

      worksheet["!cols"] = headers.map((header, index) => {

        const maxLength = Math.max(

          String(header).length,

          ...excelRows.map((row) =>

            String(row[index] ?? "").split("\n")[0].length

          )

        );



        return { wch: Math.min(Math.max(maxLength + 3, 14), 40) };

      });



      // Wrap multiline scheduled visits in Excel cells.

      for (let rowIndex = 1; rowIndex <= excelRows.length; rowIndex++) {

        for (let colIndex = 0; colIndex < headers.length; colIndex++) {

          const cellAddress = XLSX.utils.encode_cell({

            r: rowIndex,

            c: colIndex,

          });



          if (worksheet[cellAddress]) {

            worksheet[cellAddress].s = {

              alignment: { wrapText: true, vertical: "top" },

            };

          }

        }

      }



      worksheet["!autofilter"] = {

        ref: XLSX.utils.encode_range({

          s: { r: 0, c: 0 },

          e: {

            r: excelRows.length,

            c: Math.max(headers.length - 1, 0),

          },

        }),

      };



      const workbook = XLSX.utils.book_new();



      XLSX.utils.book_append_sheet(

        workbook,

        worksheet,

        "Journey Plans"

      );



      const fileTitle =

        (title || "export")

          .toLowerCase()

          .replace(/\s+/g, "-")

          .replace(/[^a-z0-9-]/g, "") || "export";



      XLSX.writeFile(

        workbook,

        `${fileTitle}-${new Date().toISOString().slice(0, 10)}.xlsx`

      );



      showSuccess(

        `Excel export completed. ${allRows.length} records exported.`

      );

    } catch (error) {

      console.error("Excel export error:", error);



      showError(

        error?.response?.data?.message ||

        error?.message ||

        "Unable to export Excel file."

      );

    }

  };







  // TABLE COLUMNS



  // ==========================================================







  const tableColumns =



    typeof columns ===



      "function"







      ? columns({







        onEdit:



          handleEdit,







        onDelete:



          handleDelete,







      })







      : columns;











  // ==========================================================



  // RENDER



  // ==========================================================







  return (







    <div



      className="mt-5"



    >











      {/* ====================================================



          SEARCH



      ==================================================== */}







      {showSearch && (







        <div



          className="mb-4"



        >







          <input







            className="



              w-full



              rounded-lg



              border



              border-gray-300



              p-3



              outline-none



              focus:border-brand-500



            "







            placeholder="Search..."







            value={



              search



            }







            onChange={



              (



                event



              ) => {







                setSearch(



                  event.target.value



                );











                if (



                  !localSearch



                ) {







                  setPage(



                    1



                  );







                }







              }



            }







          />







        </div>







      )}











      {/* ====================================================



          FILTERS



      ==================================================== */}







      {filters.length >



        0 && (







          <div



            className="



            mb-5



            rounded-xl



            border



            border-gray-200



            bg-white



            p-4



          "



          >







            <div



              className="



              mb-4



              flex



              items-center



              justify-between



            "



            >







              <div>







                <h3



                  className="



                  text-sm



                  font-bold



                  text-gray-800



                "



                >







                  Filters







                </h3>











                <p



                  className="



                  text-xs



                  text-gray-500



                "



                >







                  Filter records







                </p>







              </div>











              {hasActiveFilters && (







                <button







                  type="button"







                  onClick={



                    handleClearFilters



                  }







                  className="



                  text-sm



                  font-semibold



                  text-brand-500



                  hover:underline



                "







                >







                  Clear Filters







                </button>







              )}







            </div>











            <div



              className="



              flex



              flex-wrap



              gap-4



            "



            >







              {
                filters.map(renderFilter)

              }

            </div>
          </div>
        )}

      {/* ====================================================MPORT / EXPORT==================================================== */}

      <div className="mb-4 flex items-center justify-end gap-3">

        {/* ================================================== HIDDEN FILE INPUT================================================== */}


        {isAdmin && importData && (

          <input

            ref={importInputRef}
            type="file"
            accept={importAccept}
            onChange={handleImportFile}
            className="hidden"
          />
        )}


        {/* ==================================================IMPORT BUTTON================================================== */}

        {isAdmin && importData && (

          <button type="button" onClick={handleImportClick} disabled={loading ||importing} className="inline-flex items-center gap-2 rounded-lg border border-blue-200 bg-blue-50 px-4 py-2.5 text-sm font-semibold text-blue-700 transition hover:border-blue-300 hover:bg-blue-100 disabled:cursor-not-allowed disabled:opacity-50">

            <span>

              {importing? "⏳": "↑"}

            </span>
            {
              importing ? "Importing..." : "Import CSV / Excel"

            }
          </button>
        )}

        {/* ==================================================EXPORT BUTTON================================================== */}







        {isAdmin && (
          <button







            type="button"







            onClick={



              handleExport



            }







            disabled={



              loading ||



              filteredRows.length === 0



            }







            className="



            inline-flex



            items-center



            gap-2



            rounded-lg



            border



            border-green-200



            bg-green-50



            px-4



            py-2.5



            text-sm



            font-semibold



            text-green-700



            transition



            hover:border-green-300



            hover:bg-green-100



            disabled:cursor-not-allowed



            disabled:opacity-50



          "







          >







            <span>



              ↓



            </span>











            Export Excel







          </button>
        )}







      </div>











      {/* ====================================================



          TABLE



      ==================================================== */}







      <DataTable







        title={



          title



        }







        columns={



          tableColumns



        }







        data={



          filteredRows



        }







        loading={



          loading



        }







        onAdd={



          handleAdd



        }







        addButtonText={



          addButtonText



        }







        pagination={false}







      />











      {/* ====================================================



    PAGINATION



\\==================================================== */}







      {!localSearch && (



        <div



          className="



      mt-5



      flex



      flex-col



      gap-4



      sm:flex-row



      sm:items-center



      sm:justify-between



    "



        >







          {/* ==================================================



        PAGE INFORMATION



    ================================================== */}







          <p



            className="



        text-sm



        text-gray-500



      "



          >



            Showing Page{" "}



            <span className="font-semibold text-gray-700">



              {page}



            </span>{" "}



            of{" "}



            <span className="font-semibold text-gray-700">



              {pagination.totalPages || 1}



            </span>



          </p>











          {/* ==================================================



        PAGINATION CONTROLS



    ================================================== */}







          <div



            className="



        flex



        items-center



        gap-1



      "



          >







            {/* ==================================================



          PREVIOUS



      ================================================== */}







            <button



              type="button"







              disabled={



                page <= 1 ||



                loading



              }







              onClick={() => {



                if (



                  page > 1 &&



                  !loading



                ) {



                  setPage(



                    (currentPage) =>



                      currentPage - 1



                  );



                }



              }}







              className="



          rounded-lg



          border



          border-gray-200



          bg-white



          px-4



          py-2



          text-sm



          font-medium



          text-gray-700



          transition



          hover:bg-gray-50



          disabled:cursor-not-allowed



          disabled:opacity-40



        "



            >



              Previous



            </button>











            {/* ==================================================



          PAGE NUMBERS



      ================================================== */}







            <div



              className="



          flex



          items-center



          gap-1



        "



            >







              {getPaginationPages(



                page,



                pagination.totalPages || 1



              ).map(



                (



                  pageNumber,



                  index



                ) => {







                  // ----------------------------------------------



                  // ELLIPSIS



                  // ----------------------------------------------







                  if (



                    pageNumber === "..."



                  ) {







                    return (



                      <span



                        key={`ellipsis-${index}`}



                        className="



                    flex



                    h-9



                    min-w-9



                    items-center



                    justify-center



                    px-1



                    text-sm



                    text-gray-400



                  "



                      >



                        ...



                      </span>



                    );







                  }











                  // ----------------------------------------------



                  // PAGE BUTTON



                  // ----------------------------------------------







                  const isActive =



                    pageNumber === page;











                  return (



                    <button



                      key={pageNumber}







                      type="button"







                      disabled={



                        loading ||



                        isActive



                      }







                      onClick={() => {







                        if (



                          !loading &&



                          pageNumber !== page



                        ) {







                          setPage(



                            pageNumber



                          );







                        }







                      }}







                      className={`



                  flex



                  h-9



                  min-w-9



                  items-center



                  justify-center



                  rounded-lg



                  border



                  px-3



                  text-sm



                  font-medium



                  transition







                  ${isActive



                          ? `



                        border-brand-500



                        bg-brand-500



                        text-white



                      `



                          : `



                        border-gray-200



                        bg-white



                        text-gray-700



                        hover:bg-gray-50



                      `



                        }







                  disabled:cursor-default



                `}



                    >



                      {pageNumber}



                    </button>



                  );







                }



              )}







            </div>











            {/* ==================================================



          NEXT



      ================================================== */}







            <button



              type="button"







              disabled={



                page >=



                (pagination.totalPages || 1) ||



                loading



              }







              onClick={() => {







                if (



                  page <



                  (pagination.totalPages || 1) &&



                  !loading



                ) {







                  setPage(



                    (currentPage) =>



                      currentPage + 1



                  );







                }







              }}







              className="



          rounded-lg



          border



          border-gray-200



          bg-white



          px-4



          py-2



          text-sm



          font-medium



          text-gray-700



          transition



          hover:bg-gray-50



          disabled:cursor-not-allowed



          disabled:opacity-40



        "



            >



              Next



            </button>







          </div>







        </div>



      )}











      {/* ====================================================



          MODAL



      ==================================================== */}







      <Modal







        open={



          openModal



        }







        onClose={() =>



          setOpenModal(



            false



          )



        }







        reload={



          loadData



        }







        item={



          selectedItem



        }







        {...modalProps}







      />







    </div>







  );







}